

import { ModelSelect, ModelListSelect  } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'


import UMUM from '../../library/umum'
import DATA_MASTER from '../../library/dataMaster'
import FETCHING from '../../library/fetching'


import Joi from "joi";

const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
  });



export default {
  components: {
      ModelSelect, ModelListSelect, 
  },

  data() {
    return {
      
      status:'',

      form : {
        uraian : '',
        keterangan : '',
        unit_kerja : '',
      },

       lampiran : {
          id : '',
          direktori_id : '',
          unit_kerja_id : '',
          master_type_id : 1,
          uraian : '',
          keterangan : '',
          file : null,
          file_type : '',
          status_wali : 0,
          status_opd : 0,
          notice : '',
           file_old : null,
        },

        dataku: {
            id : '',
            username : "",
            hp: "",
            email: "",
            nip : '',
            password : "",
            confirmPassword: "",
            menu_klp : 0,
            unit_kerja : '',
            metode_absen : 1,
        },


      filterku : {
        instansi : '',
        unit_kerja : '',
        fileStat : false,
      },
     
      folder : {
          id : '',
          status : 0,
          notice : '',
        },
    
      list_data : [],
      list_klp : [],
      lokasi : [],
      checkAll : true,

      errorMessage: '',
      signingUp : false,
    
      UMUM : UMUM,
      DATA_MASTER : DATA_MASTER,
      FETCHING : FETCHING,

      nm_jabatan : '',
      nm_unit_kerja : '',

      instansi_id : '',
      unit_kerja : '',
      unit_kerja_full : '',
      unit_kerja_edit : '',

      page_first: 1,
      page_last: 0,
      page_limit : 10,
      cari_value: "",

      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      mdl_add_file : false,
      
      mdl_lihat : false,
      mdl_list : false,
      mdl_open : false,
      mdl_list_hasil : false,
      mdl_hapus_file : false,

      mdl_keterangan : false,
      mdl_keterangan_folder : false,


      mdl_list_direktori: false,

      file_path: this.$store.state.url.URL_APP + "uploads/",

      nama_keterangan: "",

      uraian:"",

      cariNamaPegawai : '',
      list_penyesuaian_absensi_asn : [],
      list_lampiran : [],
      list_hasil:[],
    }
  },
  methods: {

    getcheckAll : function () {

console.log("===========");
  // this.lokasi = this.$store.state.listOPD

if (this.checkAll==true) {
  
  this.lokasi = this.$store.state.list_biodata
  console.log(this.lokasi);
  
  this.checkAll = false
} else {
  this.lokasi = []
  this.checkAll = true
  
}

},




    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "view", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                // unit_kerja : this.unit_kerja,
                status : this.status,
                unit_kerja : this.filterku.unit_kerja,
                instansi : this.filterku.instansi,
                penyesuaian_absensi_id : this.id_penyesuaian_absensi,
          })
      })
          .then(res => res.json())
          .then(res_data => {

            console.log(res_data);
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              console.log(this.list_data + "siap");
      });
    },

    getView1 : function(a){
      fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "view1", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id_penyesuaian_absensi : a,
          })
      })
          .then(res => res.json())
          .then(res_data => {
            this.list_penyesuaian_absensi_asn = res_data;

            this.uraian = this.list_penyesuaian_absensi_asn[0].uraian;
            this.total_file = this.list_penyesuaian_absensi_asn.map(total => total.proses).reduce((acc, amount) => acc + amount);
            this.nama_keterangan = this.list_penyesuaian_absensi_asn[0].keterangan;
            
      });
    },

    addData : function() {
      fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            form : this.form,
            lokasi:this.lokasi
          }
          )
      }).then(res_data => {
          this.getView();
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
      });
    },

    editData: function() {
        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "editData", {
            method: "POST",
            headers: {
                'content-type' : 'application/json',
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Mengubah Data', 'primary', 'check_circle_outline');
            this.getView();
        });
    },

    removeData : function(idnya){
      fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "removeData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(
                    {
                  id : this.form.id
                 
                }
              )
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
        });
    },

    removeDataFile : function(idnya){
      fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "removeDataFile", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.lampiran)
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getLampiran(this.lampiran.penyesuaian_absensi_id, this.lampiran.nip);
        });
    },

    selectFolder : function(data){ 
         this.folder.id = data.id;
          this.folder.status = data.status;
          this.folder.notice = data.notice;

      },

    selectData : function(data){
        // console.log(data)
        this.form.id = data.id;
        this.form.uraian = data.uraian;
        this.form.keterangan = data.keterangan;
        this.form.unit_kerja = data.unit_kerja;

    
    },

    select1(data){
        // this.lampiran.direktori_id = data.id
        this.getView1(data.id)
      },

      select2(data){
        this.lampiran.penyesuaian_absensi_id = data.id
        this.lampiran.nip = data.nip
        this.lampiran.unit_kerja_id = data.unit_kerja_id

        this.getLampiran(data.id, data.nip);
        
        this.getTanggapan(data.id, data.nip) 
        
      },

      getTanggapan : function(penyesuaian_absensi, nip){
   
          fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "hasil", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  penyesuaian_absensi_id : penyesuaian_absensi,
                  nip : nip,

              })
          })
              .then(res => res.json())
              .then(res_data => {
                console.log("AAAAAAAAAAAA " + res_data.data)
                this.list_hasil = res_data.data;
          });
        },

      selectLampiran : function(data){
        // console.log(data.file + "asubabi");
        
        this.lampiran.id = data.id;
        this.lampiran.penyesuaian_absensi_id = data.penyesuaian_absensi_id;
        this.lampiran.nip = data.nip;
        this.lampiran.unit_kerja_id = data.unit_kerja_id;
        this.lampiran.uraian = data.uraian;
        this.lampiran.keterangan = data.keterangan;
        this.lampiran.status = data.status;
        this.lampiran.notice = data.notice;
        this.lampiran.file_old =  data.file
        this.lampiran.file = this.lampiran.file

        // this.form.unit_kerja_id = data.unit_kerja_id;
        },

      getLampiran : function(penyesuaian_absensi){

        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + "viewLampiran", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                penyesuaian_absensi_id : penyesuaian_absensi,
                unit_kerja_id :  this.lampiran.unit_kerja_id,
                nip : this.lampiran.nip,
            })
        })
            .then(res => res.json())
            .then(res_data => {
              console.log(res_data)
              this.list_lampiran = res_data
        });
      },

      addLampiran: function(){

        var formData = new FormData();
        formData.append('pb', JSON.stringify(this.lampiran));
        formData.append('file', this.lampiran.file);

        fetch(this.$store.state.url.URL_PENYESUAIAN_ABSENSI + 'addDataLampiran', {
            method: "POST",
            headers: {
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
            }).then(res_data => {
              
              // this.lampiran.direktori_id
                this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
              var a = this.lampiran.penyesuaian_absensi_id
              var b = this.lampiran.unit_kerja_id 
              this.getLampiran(a, b); 
              this.getView1(this.form.id);
        });
        },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx;
        },



        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        selectBiodata (item) {
          return `${item.nama} | NIP. ${item.nip}`
        },


        getAsyncPost : async function() {
          this.list_klp = await FETCHING.postMasterKlpMenu();
        },

        cariNama : async function(){
          this.$store.state.list_biodata = await FETCHING.FETCH_POST(this.$store.state.url.URL_simpeg_biodata + "cariNama", {cari : this.cariNamaPegawai, unit_kerja : this.unit_kerja} )
          this.getView();
        },

    // ====================================== PAGINATE ====================================
  },

  mounted () {

    var get_profile = JSON.parse(localStorage.profile);
    this.filterku.unit_kerja = get_profile.profile.unit_kerja;
    this.filterku.instansi = get_profile.profile.instansi_id;
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;
    this.form.unit_kerja = get_profile.profile.unit_kerja;

    this.status = get_profile.profile.penyesuaian_absensi;

    this.dataku.unit_kerja = get_profile.profile.unit_kerja;

    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);
    DATA_MASTER.getBiodata(this.dataku.unit_kerja);
    
    this.getAsyncPost()

    this.getView();

    this.cariNama();


  },
}
